import React, { useState } from 'react'

import Select from "react-select"
import Creatable from 'react-select/creatable'
import { Dropdown, Tabs, Menu } from 'antd'

import { BiSelectMultiple } from 'react-icons/bi'

import { normalize, stringifyDate, useListData, usePet, useToggle } from '../../modules'

import Modal from "../resusable/modal"
import Receive from '../resusable/receive'
import NewInventoryItem from './newinventoryitem'
import EditItem from './editItem'

const { TabPane } = Tabs

const NewInvoice = ({ toggle, visible, onPerform }) => {
    const [suppliers, setSuppliers] = useState([])
    const [supplier, setSupplier] = useState()
    const [selected, setSelected] = useState(null)
    const [key, setKey] = useState(null)
    const [item, setItem] = useState([])
    const [string, setString] = useState('')
    const [code, setCode] = useState('')

    const [newItem, toggleNewItem] = useToggle()
    const [editModal, toggleEditModal] = useToggle()

    const [
        { loading: invLoading, fetch: fetchInvItems },
        { list: items = [] }
    ] = useListData('inventoryItems', { string }, { notify: true }, 'items')

    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchInvItems()
        }
    }

    const [{ }, getSuppliers] = usePet('suppliers', {}, { notify: true, callback: ({ data }) => setSuppliers(data), logOutOnError: true })

    const onComplete = () => {
        onPerform()
        getSuppliers()
        setTimeout(toggle, 300)
    }

    const [{ loading: newLoading }, newInvoice] = usePet('newInInvoice', {
        code, 
        commit: false, 
        items: item.map(itm => ({
            item: itm._id, 
            bulkCount: itm.bulk, 
            quantity: itm.contains, 
            bp: itm.bp,
            discount: itm.discount,
            vat: itm.vat
        })), 
        supplier: supplier?.label
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Receiving invoice...' } })

    const [{ loading: newCmLoading }, newInvoiceAndCommit] = usePet('newInInvoice', {
        code, 
        commit: true,
        items: item.map(itm => ({
            item: itm._id, 
            bulkCount: itm.bulk, 
            quantity: itm.contains,  
            bp: itm.bp,
            discount: itm.discount,
            vat: itm.vat
        })), 
        supplier: supplier?.label
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Receiving invoice...' } })

    const selectItems = (item, i) => {
        setSelected({
            item,
            ...item
        })
        setKey(i)
        toggleEditModal()
    }

    return (
        <Modal
            h="h-auto my-5"
            // w="w-5/6 md:w-4/5 xl:w-3/5 2xl:w-2/5 mt-5"
            align="items-start"
            title="Receive Invoice"
            toggle={toggle}
            visible={visible}>
            {
                newItem &&
                <NewInventoryItem
                    string={string}
                    onPerform={ x => {
                        setItem([...item, { ...x, label: x.name, value: x }])
                    }}
                    toggle={toggleNewItem}
                    visible={newItem} />
            }
            {
                editModal &&
                <EditItem
                    onPerform={ val => {
                        let temp = [...item]
                        temp[key] = val
                        setItem(temp)
                    } }
                    record={ selected }
                    toggle={ toggleEditModal }
                    visible={ editModal } />
            }
            <div className="sm:flex items-center mb-8">
                {/* <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" /> */}

                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Invoice Code
                    </label>
                    <input
                        onChange={e => setCode(e.target.value)}
                        className="appearance-none block max-w-4xl mr-4 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-inv-item"
                        type="text"
                        placeholder="C-1234" />
                </div>
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Supplier
                    </label>
                    <Creatable
                        value={supplier}
                        onCreateOption={val => {
                            let temp = [...suppliers]
                            temp.push(val)
                            setSuppliers(temp)
                            setSupplier({ label: val, value: val })
                        }}
                        onChange={setSupplier}
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                        options={suppliers.map(sup => ({ label: sup, value: sup === 'All Suppliers' ? 'All' : sup }))}
                        placeholder="Select Supplier" />
                </div>
            </div>
            <div className="sm:flex justify-center items-center mb-8">
                <Creatable
                    isMulti
                    onCreateOption={toggleNewItem}
                    isLoading={invLoading}
                    loadingMessage={str => `Searching for "${str?.inputValue}"`}
                    onInputChange={search}
                    value={item}
                    onChange={setItem}
                    // styles={{ input: styles => ({ ...styles, minWidth: '25em' }) }}
                    options={items.map(itm => ({ 
                        label: itm.name, 
                        value: itm, 
                        name: itm.name,
                        bulk: 1,
                        contains: 1, 
                        bp: 0, 
                        discount: 0, 
                        vat: 16, 
                        ...itm 
                    }))}
                    placeholder="Search for inventory item" />
            </div>
            {
                item.length > 0 ?
                    <table className="table-auto w-full">
                        {/* Table header */}
                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                            <tr>
                                <th className="p-2">
                                    <div className="font-semibold text-left">No</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Item</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Quantity</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Price</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Disc</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Tax</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Total</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-center"></div>
                                </th>
                            </tr>
                        </thead>
                        {/* Table body */}
                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                            {
                                item.map((itm, key) =>
                                    <tr>
                                        <td className="p-2">
                                            <div className="text-center">{key + 1}.</div>
                                        </td>
                                        <td className="p-2">
                                            <div className="">{itm.label}</div>
                                        </td>
                                        <td className="p-2 text-left">
                                            <div className="text-left">{ itm.bulk } X { itm.contains } ({ itm.bulk * itm.contains })</div>
                                        </td>
                                        <td className="p-2">
                                            <div className="text-left">Ksh. { normalize(itm?.bp) }</div>
                                        </td>
                                        <td className="p-2 text-left">
                                            <div className="text-left">Ksh. { normalize(itm?.discount) }</div>
                                        </td>
                                        <td className="p-2 text-left">
                                            <div className="text-left">{itm?.vat}</div>
                                        </td>
                                        <td className="p-2 text-left">
                                            <div className="text-left">Ksh. { normalize((itm.bulk * itm.contains) * (itm.bp - itm.discount)) }</div>
                                        </td>
                                        <td className="p-2">
                                            <button onClick={ () => selectItems(itm, key) } className="btn hisani-btn-green text-white">
                                                <span className="hidden xs:block mr-2">Edit</span>
                                            </button>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                :
                <div className="w-full h-16 flex items-center justify-center">
                    <p className="font-semibold text-base">Please select items to add to invoice</p>
                </div>
            }
            <div className="flex justify-end mt-2">
                <button disabled={ newCmLoading } onClick={ newInvoiceAndCommit } className="text-white hisani-btn-orange mr-3 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Receive & Commit Invoice</button>
                <button disabled={ newLoading } onClick={ newInvoice } className="text-white hisani-btn-green mr-3 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Receive Invoice</button>
                <button onClick={ toggle } className="text-white bg-gray-700 hover:bg-gray-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
            </div>
        </Modal>
    )
}

export default NewInvoice